/*
 * Cottomix theme: PDP gallery image download (cm-gallery-download.js), owner 2026-10-25.
 *
 * Every gallery photo has a small download button (a.cm-gallery__download,
 * data-cm-download) that points at the full-resolution original on the Shopify
 * CDN. A click fetches it as a blob and saves it through a[download]. If the
 * fetch fails or the response is not an image, the original opens in a new tab
 * (long-press save works there). The photo itself is not covered by any
 * overlay: the button sits in the top-end corner only.
 */
(function () {
  'use strict';

  var EXT = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'image/avif': 'avif' };

  function nameFor(name, type) {
    var ext = EXT[type];
    if (!ext) return name;
    return name.replace(/\.[a-z0-9]+$/i, '') + '.' + ext;
  }

  function save(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.setTimeout(function () {
      a.remove();
      URL.revokeObjectURL(url);
    }, 4000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cm-download]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var src = btn.getAttribute('href');
    var name = btn.getAttribute('data-download-name') || 'product-image.jpg';
    if (!src) return;
    btn.setAttribute('aria-busy', 'true');
    fetch(src, { mode: 'cors', credentials: 'omit', cache: 'force-cache' }).then(function (res) {
      if (!res.ok) throw new Error('http ' + res.status);
      var type = (res.headers.get('content-type') || '').split(';')[0].trim().toLowerCase();
      if (type.indexOf('image/') !== 0) throw new Error('not an image: ' + type);
      return res.blob().then(function (blob) { save(blob, nameFor(name, type)); });
    }).catch(function () {
      window.open(src, '_blank', 'noopener');
    }).then(function () {
      btn.removeAttribute('aria-busy');
    });
  }, false);
})();
